"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.rahtabCardId = exports.nationalIdValidation = exports.mobileNumValidation = exports.mobileValidation = exports.handleHelperText = void 0;
const yup = __importStar(require("yup"));
const handleHelperText = (name, errors) => {
    let helperText = '';
    if (errors) {
        errors.inner.forEach((err) => {
            if (err.path === name) {
                helperText = err.message;
            }
            return;
        });
    }
    return helperText;
};
exports.handleHelperText = handleHelperText;
const phone = /^09\d{9}$/;
exports.mobileValidation = yup
    .string()
    .matches(phone, 'شماره وارد شده معتبر نیست.')
    .required('وارد کردن شماره همراه الزامی می‌باشد.');
exports.mobileNumValidation = yup.object().shape({
    mobileNumber: yup
        .string()
        .matches(phone, 'شماره‌ای که وارد کرده‌اید صحیح نمی‌باشد.')
        .required('وارد کردن شماره همراه الزامی می‌باشد.'),
});
exports.nationalIdValidation = yup
    .string()
    .transform((v) => v || undefined)
    .test('', 'کد ملی وارد شده معتبر نمی‌باشد.', (value) => {
    if (value === undefined) {
        return true;
    }
    else if (!/^\d{10}$/.test(value) ||
        value === '0000000000' ||
        value === '1111111111' ||
        value === '2222222222' ||
        value === '3333333333' ||
        value === '4444444444' ||
        value === '5555555555' ||
        value === '6666666666' ||
        value === '7777777777' ||
        value === '8888888888' ||
        value === '9999999999') {
        return false;
    }
    const check = parseInt(value[9], 10);
    let sum = 0;
    let i;
    for (i = 0; i < 9; ++i) {
        sum += parseInt(value[i], 10) * (10 - i);
    }
    sum %= 11;
    return (sum < 2 && check === sum) || (sum >= 2 && check + sum === 11);
});
exports.rahtabCardId = yup
    .string()
    .transform((v) => v || undefined)
    .test('', 'شناسه رهتاب کارت وارد شده معتبر نمی‌باشد.', (value) => {
    if (value === undefined) {
        return true;
    }
    else if (!/^\d{12}$/.test(value) ||
        value === '000000000000' ||
        value === '111111111111' ||
        value === '222222222222' ||
        value === '333333333333' ||
        value === '444444444444' ||
        value === '555555555555' ||
        value === '666666666666' ||
        value === '777777777777' ||
        value === '888888888888' ||
        value === '999999999999') {
        return false;
    }
    const check = parseInt(value[11], 10);
    let sum = 0;
    let i;
    for (i = 0; i < 11; ++i) {
        sum += parseInt(value[i], 10) * (12 - i);
    }
    sum %= 13;
    return (sum < 4 && check === sum) || (sum >= 4 && check + sum === 13);
});
